import {SolutionOrderLegDto} from "../adjustment-pricing-grid/model/SolutionOrderLegDto";
import {CashFlowStrategyRole} from "../shell-communication/shell-dto-protocol";
import {HedgeOrder} from "../hedging-grid/data-model/hedge-order";
import {OrdersGroupToRegroup} from "./OrdersGroupToRegroup";
import {OptionType} from "../options-common/options.model";
import {ActionType} from "../multi-trade-pad/multi-trade-pad.model";
import {MlPadLeg} from "./MlPadLeg";

export class OrderToRegroupWrapper {
    constructor(
        private readonly _order: SolutionOrderLegDto | HedgeOrder | MlPadLeg,
        public readonly color?: string | undefined,
    ) {
    }

    get order(): SolutionOrderLegDto | HedgeOrder | MlPadLeg {
        return this._order;
    };

    get ticker(): string {
        return this._order.ticker;
    };

    get action(): string {
        return this._order.action;
    };

    get underlying(): string {
        const ord = this._order as any;
        return ord.underlying || ord.asset;
    };

    get type(): 'Call' | 'Put' {
        return this._order.type;
    };

    get strike(): string {
        return this._order.strike + '';
    };

    get expiration(): string {
        return this._order.expiration;
    };

    get role(): CashFlowStrategyRole {
        return (this._order as any).role;
    };

    get price(): number {
        return this._order.price;
    };

    get qty(): number {
        return this._order.qty;
    };

    settledQty = 0;

    group: OrdersGroupToRegroup;

    get leftOverQty(): number {
        return this.qty - (this.settledQty || 0);
    }

    get isSettled(): boolean {
        return this.settledQty === this.qty;
    }

    adjustSettledQty(qty: number): boolean {
        const newSettledQty = (this.settledQty || 0) + qty;

        if (Math.abs(newSettledQty) > Math.abs(this.qty)) {
            return false;
        }

        this.settledQty += qty;

        return true;
    }
}

export class DropZoneOrder {
    constructor(
        private readonly _order: OrderToRegroupWrapper,
        qty?: number,
    ) {
        // A hand-dragged leg takes everything that is left, as it always has. "Optimal Order
        // Arrangement" passes an explicit slice instead, because the whole point of the split is
        // that one source row feeds several orders.
        this.qty = typeof qty === 'number' ? qty : _order.leftOverQty;
        _order.adjustSettledQty(this.qty);
    }

    get ticker(): string {
        return this._order.ticker;
    };

    get action(): string {
        return this._order.action;
    };

    ownAction: string;

    get underlying(): string {
        return this._order.underlying;
        // const ord = this._order.order as any;
        // return ord.underlying || ord.asset;
    };

    get asset(): string {
        return this.underlying;
    }

    get type(): 'Call' | 'Put' {
        return this._order.type;
    };

    get strike(): string {
        return this._order.strike + '';
    };

    get expiration(): string {
        return this._order.expiration;
    };

    get role(): CashFlowStrategyRole {
        return (this._order as any).role;
    };

    get price(): number {
        return this._order.price;
    };

    qty: number;

    get order(): SolutionOrderLegDto | HedgeOrder | MlPadLeg {
        return this._order.order;
    };

    get color() {
        return this._order.color;
    }

    group: OrdersGroupToRegroup;

    adjustSettledQty(delta: number): boolean {
        return this._order.adjustSettledQty(delta);
    }

    onRemoved() {
        this._order.adjustSettledQty(-this.qty);
        (this._order as any).moved = false;
    }
}